var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "registryservices" },
    [
      _c("PageHeader", {
        attrs: {
          title: "Manage Services",
          icon: "settings",
          subtitle:
            "Manage services and configurations, and view execution logs.",
        },
      }),
      _vm._v(" "),
      _c("ServiceLinks", {
        staticClass: "mb-4",
        attrs: { services: _vm.services, isLoaded: _vm.fetchedServices },
      }),
      _vm._v(" "),
      _c("ServiceRefreshTokens", { staticClass: "mb-4" }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Services", search: "services" },
          model: {
            value: _vm.searchText,
            callback: function ($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText",
          },
        },
        [
          _c("RegisterServiceDialog"),
          _vm._v(" "),
          _c("InstallServicesDialog"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "register-service-btn",
              attrs: { color: "warning" },
              nativeOn: {
                click: function ($event) {
                  return _vm.getServices()
                },
              },
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("refresh")]),
              _vm._v("\n      Refresh Service\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "v-layout",
            { staticStyle: { "padding-top": "150px" } },
            [_c("PageLoader", { attrs: { resourceName: "Services" } })],
            1
          )
        : [
            _c(
              "v-layout",
              { attrs: { "row-wrap": "" } },
              [
                [
                  _c(
                    "v-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { dark: "", grow: "", centered: "" },
                    },
                    [
                      _vm._l(
                        _vm.serviceGroupings,
                        function (serviceGrouping, index) {
                          return _c(
                            "v-tab",
                            {
                              key: index,
                              on: {
                                click: function ($event) {
                                  return _vm.setCurrentTab(index)
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v(_vm._s(serviceGrouping.icon)),
                              ]),
                              _vm._v(
                                "\n            " +
                                  _vm._s(serviceGrouping.name) +
                                  "\n          "
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.serviceGroupings,
                        function (serviceGrouping, index) {
                          return _c(
                            "v-tab-item",
                            { key: `tabs-${index}` },
                            [
                              _vm.currentTab == index
                                ? _c(serviceGrouping.component, {
                                    tag: "component",
                                    attrs: { services: _vm.filteredServices },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ],
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }